import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../../environment";

const EMPLOYEE_BASE_URL = API_BASE_PATH;

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

export const getAllEmployees = async (token: string | null) => {
  try {
    const response = await axios.get(
      `${EMPLOYEE_BASE_URL}/register/admin/all`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    const message = extractErrorMessage(error);
    console.error("❌ Error fetching all employees:", message);
    toast.error(message);
    throw error;
  }
};
